if (document.readyState === "complete" || document.readyState === "loaded") {
  runHeaderFunctions();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runHeaderFunctions();
  });
}

function runHeaderFunctions() {
  const parentMenus = document.querySelectorAll(
    "[data-parent-menu-has-children]"
  );

  // Only applies to desktop
  // Grab menu links that have a data attribute of parent-menu-has-children
  // Loop through them
  parentMenus.forEach((parent) => {
    const parentBannerNav = parent.querySelector("[data-banner-images]");

    // On hover, add the class of active
    parent.addEventListener("mouseenter", function () {
      parentBannerNav.classList.add("active");
    });

    // Stopping hover, remove the class of active
    parent.addEventListener("mouseleave", function () {
      parentBannerNav.classList.remove("active");
    });
  });

  const linksWithBanners = document.querySelectorAll("[data-link-id]");

  linksWithBanners.forEach((link) => {
    link.addEventListener("mouseover", function () {
      if (link.dataset.linkId !== "") {
        document.querySelectorAll("[data-image-id]").forEach((item) => {
          //item.classList.remove("active");
        });
        const linkId = link.dataset.linkId;
        if (document.querySelector(`[data-image-id=${linkId}]`)) {
          document
            .querySelectorAll(`[data-image-id=${linkId}]`)
            .forEach((el) => {
              el.classList.add("active");
            });
        }
      }
    });
  });

  // Grab see all collabs button node
  let collabSeeAll = document.querySelectorAll("[data-collabs]");

  // Find the hidden collab links
  const collabHiddenLinks = document.querySelectorAll(
    "[data-collab-link-shown]"
  );

  let = collabsMenuHeight = 0;
  const collabsMenu = document.querySelector(
    '[data-parent-menu-has-children="collabs"] .site-nav__submenu--children-list'
  );
  const desktopGrandchildMenus = document.querySelectorAll(
    "[data-grandchildren-list]"
  );
  // Adding click events for each collab see all button & changing text when it's clicked
  collabSeeAll.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      if (button.textContent == "See More") {
        button.textContent = "See Less";
      } else {
        button.textContent = "See More";
      }
      collabHiddenLinks.forEach((link) => {
        if (link.dataset.collabLinkShown == "true") {
          link.dataset.collabLinkShown = "false";
        } else {
          link.dataset.collabLinkShown = "true";
        }
      });
      collabsMenuHeight = collabsMenu.scrollHeight;
      desktopGrandchildMenus.forEach((menu) => {
        menu.style.height = `${collabsMenuHeight}px`;
      });
    });
  });

  let mobileScrollTop = 0;
  // Opens child menu of parent link when clicked
  const hasSubmenu = document.querySelectorAll("[data-open-menu]");
  hasSubmenu.forEach((menu) => {
    const menuToOpen = menu.dataset.openMenu;
    menu.addEventListener("click", function (e) {
      e.preventDefault();

      // Set the top style property to the scrolled position
      document.querySelector(
        `[data-accordion-content=${menuToOpen}]`
      ).style.top = `${mobileScrollTop}px`;

      // Stall for 250ms to let top style property change for adding active class
      setTimeout(function () {
        document
          .querySelector(`[data-accordion-content=${menuToOpen}]`)
          .classList.add("active");
      }, 250);

      // Update scroll tracking variable
      menu.nextElementSibling.addEventListener("scroll", function () {
        mobileScrollTop = menu.nextElementSibling.scrollTop;
      });
    });
  });

  // Close/back buttons that disable active state on click
  const closeButton = document.querySelectorAll("[data-close-menu]");
  closeButton.forEach((button) => {
    const menuToClose = button.dataset.closeMenu;
    button.addEventListener("click", function (e) {
      e.preventDefault();
      document
        .querySelector(`[data-accordion-content=${menuToClose}]`)
        .classList.remove("active");
    });
  });

  // Grab the outermost parent menu & current parent menu
  // from the child and add a class to disable Y axis scrolling

  // Outermost mobile nav
  const mainMobileNav = document.querySelector(".mobile-drawer-wrapper > nav");
  // Child menus
  const childMenu = document.querySelectorAll("[data-child-link]");
  // Back buttons within child menus
  const turnOffButtons = document.querySelectorAll("[data-turn-off]");

  // Grab all child menus, when clicked, disable Y axis scrolling on child menu
  childMenu.forEach((menu) => {
    menu.addEventListener("click", function () {
      document
        .querySelector(`[data-parent-link=${menu.dataset.childLink}]`)
        .classList.add("no-overflow-y");
      mainMobileNav.classList.add("no-overflow-y");
    });
  });

  // Grab all back buttons within child menus, when clicked, enable Y axis scrolling on child menu
  turnOffButtons.forEach((button) => {
    button.addEventListener("click", function () {
      document
        .querySelector(`[data-parent-link=${button.dataset.turnOff}]`)
        .classList.remove("no-overflow-y");
      mainMobileNav.classList.remove("no-overflow-y");
    });
  });

  // Keep grandchild menus open until another menu is hovered
  document
    .querySelectorAll(
      ".site-nav__submenu--children-cont.variant > .site-nav__submenu--children-list > .site-nav__item--child > a"
    )
    .forEach((item) => {
      item.addEventListener("mouseover", function () {
        document.querySelectorAll(".site-nav--has-submenu").forEach((el) => {
          el.classList.remove("active");
        });
        if (this.parentNode.classList.contains("site-nav--has-submenu")) {
          this.parentNode.classList.add("active");
        }
      });
    });
  // remove active class when overall menu is closed
  document
    .querySelectorAll(".site-nav--has-submenu.top-level")
    .forEach((item) => {
      item.addEventListener("mouseleave", function () {
        document.querySelectorAll(".site-nav--has-submenu").forEach((el) => {
          el.classList.remove("active");
        });
      });
    });

  // remove fallback hover CSS once JS is loaded
  document
    .querySelectorAll(
      ".site-nav__submenu--children-cont.variant > .site-nav__submenu--children-list > .site-nav--has-submenu"
    )
    .forEach((childMenu) => {
      childMenu.addEventListener("mouseover", function () {
        this.querySelector(
          ".site-nav__submenu--grandchildren-list"
        ).style.transform = "translateX(2000px)";
      });
    });
}
